var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('form-button');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
export var FormButtonDefaultProps = {
  type: 'submit',
  label: 'Submit',
  disabled: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    font-weight: 300;\n    background: #000;\n    font-size: 1em;\n    padding: ", ";\n    text-transform: uppercase;\n    font-family: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n\n    box-sizing: border-box;\n    \n    &:hover {\n      background: #333;\n    }\n\n    &[disabled] {\n      opacity: 0.3;\n      cursor: default;\n      background: #000;\n    }\n\n  "], ["\n    background: none;\n    border: none;\n    background: none;\n    cursor: pointer;\n    padding: 0;\n    font-weight: 300;\n    background: #000;\n    font-size: 1em;\n    padding: ", ";\n    text-transform: uppercase;\n    font-family: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n\n    box-sizing: border-box;\n    \n    &:hover {\n      background: #333;\n    }\n\n    &[disabled] {\n      opacity: 0.3;\n      cursor: default;\n      background: #000;\n    }\n\n  "])), theme.UNIT(4), theme.FONT('sans'), theme.COLOR('light'), theme.COLOR('light'))
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var FormButton = function (props) {
  var className = props.className,
    children = props.children,
    label = props.label,
    type = props.type,
    onClick = props.onClick,
    disabled = props.disabled;
  return React.createElement(My.Container, {
    disabled: disabled,
    onClick: onClick,
    type: type,
    className: cls.name(className)
  }, children || label);
};
FormButton.defaultProps = FormButtonDefaultProps;
FormButton.cls = cls;
var templateObject_1, templateObject_2;